import { useEffect } from "react";

interface SEOHeadProps {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl: string;
  ogType?: string;
  ogImage?: string;
  jsonLd?: Record<string, unknown>;
}

export default function SEOHead({
  title,
  description,
  keywords,
  canonicalUrl,
  ogType = "website",
  ogImage,
  jsonLd,
}: SEOHeadProps) {
  useEffect(() => {
    const baseUrl = "https://ribenhanou-style.com";
    const fullTitle = `${title} | 日韩欧美风格一站式精选`;
    document.title = fullTitle;
    document.querySelector('meta[name="description"]')?.setAttribute("content", description);
    document.querySelector('meta[name="keywords"]')?.setAttribute("content", keywords);

    const setMeta = (property: string, content: string, isProperty = true) => {
      const attr = isProperty ? "property" : "name";
      let el = document.querySelector(`meta[${attr}="${property}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, property);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    setMeta("og:title", fullTitle);
    setMeta("og:description", description);
    setMeta("og:type", ogType);
    setMeta("og:url", canonicalUrl);
    if (ogImage) setMeta("og:image", ogImage);

    setMeta("twitter:card", "summary_large_image", false);
    setMeta("twitter:title", fullTitle, false);
    setMeta("twitter:description", description, false);
    if (ogImage) setMeta("twitter:image", ogImage, false);

    let linkEl = document.querySelector('link[rel="canonical"]');
    if (!linkEl) {
      linkEl = document.createElement("link");
      linkEl.setAttribute("rel", "canonical");
      document.head.appendChild(linkEl);
    }
    linkEl.setAttribute("href", canonicalUrl);

    const existingScripts = document.querySelectorAll('script[type="application/ld+json"]');
    existingScripts.forEach((s) => s.remove());

    if (jsonLd) {
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.textContent = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }
  }, [title, description, keywords, canonicalUrl, ogType, ogImage, jsonLd]);

  return null;
}